'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#20_svg__clip0_39877_64173)" },
        React__namespace.createElement("path", { d: "M1.2432 2.24069C1.67278 1.81112 2.36926 1.81113 2.79883 2.24071L10.0003 9.44232L17.2017 2.24071C17.6312 1.81113 18.3277 1.81112 18.7573 2.24069C19.1869 2.67026 19.1869 3.36674 18.7573 3.79633L11.5559 10.998L18.757 18.1993C19.1865 18.6288 19.1865 19.3253 18.7569 19.7549C18.3274 20.1845 17.6309 20.1845 17.2013 19.7549L10.0003 12.5536L2.79919 19.7549C2.36962 20.1845 1.67314 20.1845 1.24356 19.7549C0.813974 19.3253 0.813965 18.6288 1.24354 18.1993L8.44464 10.998L1.24318 3.79633C0.813607 3.36674 0.813616 2.67026 1.2432 2.24069Z", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "20_svg__clip0_39877_64173" },
            React__namespace.createElement("rect", { width: 20, height: 20, fill: "white", transform: "translate(0 0.997681)" })))));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
